import { Controller } from '@hotwired/stimulus';
import { Application } from '@hotwired/stimulus/dist/types';

import { Dialog, hasOpenDialog } from '../../500-common/a11y-dialog';

const CLASS_DIALOG_WRAPPER_ELEMENT = 'klt-c-image-zoom-dialog';
const ATTRIBUTE_IMAGE_ZOOM_CLOSE_TRIGGER = 'data-klt-c-image-zoom-view-close';

export class ImageZoomController extends Controller {
    static targets = ['overlayTemplate'];
    static values = {
        id: {
            type: String,
            default: 'klt-image-zoom-dialog',
        },
    };

    dialog: Dialog;
    dialogInnerHtml: string;
    dialogWapperElement: HTMLDivElement;
    idValue: string;
    overlayTemplateTarget: HTMLTemplateElement;

    static register(application: Application) {
        application.register('image-zoom', this);
    }

    open(event: Event) {
        event.preventDefault();
        if (!hasOpenDialog()) {
            const innerHTML = !this.dialogInnerHtml
                ? (this.overlayTemplateTarget.content.firstElementChild.cloneNode(true) as HTMLDivElement).outerHTML
                : this.dialogInnerHtml;

            if (!this.dialogWapperElement) {
                this.dialogWapperElement = document.createElement('div');
                this.dialogWapperElement.setAttribute('role', 'dialog');
                this.dialogWapperElement.setAttribute('id', this.idValue);
                this.dialogWapperElement.classList.add(CLASS_DIALOG_WRAPPER_ELEMENT);
                document.body.appendChild(this.dialogWapperElement);
            }

            this.dialogWapperElement.innerHTML = innerHTML;

            const closeTrigger = this.dialogWapperElement.querySelector(
                `[${ATTRIBUTE_IMAGE_ZOOM_CLOSE_TRIGGER}]`
            ) as HTMLButtonElement;

            this.dialog = new Dialog(this.dialogWapperElement, this.element as HTMLElement, closeTrigger);
        }
    }
}
